"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdatePhoneNumberForm = exports.UpdateEmailForm = exports.AddPhoneNumberForm = exports.AddEmailForm = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _formik = require("formik");
var _Input = _interopRequireDefault(require("../Input"));
var _FormLabel = _interopRequireDefault(require("../FormLabel"));
var _IntlTelInput = _interopRequireDefault(require("../Input/IntlTelInput"));
var _FormErrorMessage = _interopRequireDefault(require("../FormErrorMessage"));
var _components = require("./components");
var _excluded = ["title", "subtitle", "validate", "children", "actions", "onSubmit"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var UpdateButtonGroup = function UpdateButtonGroup(_ref) {
  var disabled = _ref.disabled,
    isLoading = _ref.isLoading,
    onClose = _ref.onClose;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_components.ButtonGroup, {
    disabled: disabled,
    isLoading: isLoading,
    onClose: onClose
  }, t('button.update'));
};
var AddButtonGroup = function AddButtonGroup(_ref2) {
  var disabled = _ref2.disabled,
    isLoading = _ref2.isLoading,
    onClose = _ref2.onClose;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement(_components.ButtonGroup, {
    disabled: disabled,
    isLoading: isLoading,
    onClose: onClose
  }, t('button.add'));
};
var EmailField = function EmailField() {
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], null, t('settings.recovery.email.label')), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    autoFocus: true,
    size: "lg",
    name: "email",
    autoComplete: "off",
    className: "block w-full font-bold text-dark"
  }), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
    name: "email"
  }));
};
var PhoneNumberField = /*#__PURE__*/(0, _react.forwardRef)(function (_ref3, ref) {
  var setFieldValue = _ref3.setFieldValue,
    enabledCountries = _ref3.enabledCountries;
  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation4.t;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], null, t('settings.recovery.phone.label')), /*#__PURE__*/_react["default"].createElement(_IntlTelInput["default"], {
    autoFocus: true,
    ref: ref,
    size: "lg",
    standalone: false,
    name: "phoneNumber",
    autoComplete: "off",
    enabledCountries: enabledCountries,
    className: "block w-full font-bold text-dark",
    onChange: function onChange(e) {
      var dialCode = e.countryData.dialCode;
      setFieldValue('countryCode', dialCode);
    }
  }), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
    name: "phoneNumber"
  }));
});
var FormContainer = function FormContainer(_ref4) {
  var title = _ref4.title,
    subtitle = _ref4.subtitle,
    validate = _ref4.validate,
    children = _ref4.children,
    actions = _ref4.actions,
    onSubmit = _ref4.onSubmit,
    props = (0, _objectWithoutProperties2["default"])(_ref4, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, (0, _extends2["default"])({}, props, {
    validate: validate,
    onSubmit: onSubmit
  }), function (formikProps) {
    return /*#__PURE__*/_react["default"].createElement(_formik.Form, {
      className: "h-full"
    }, /*#__PURE__*/_react["default"].createElement(_components.Layout, {
      title: title,
      subtitle: subtitle,
      actions: actions(formikProps)
    }, children(formikProps)));
  });
};
var makeEmailForm = function makeEmailForm(actionType) {
  return function (_ref5) {
    var _ref5$isLoading = _ref5.isLoading,
      isLoading = _ref5$isLoading === void 0 ? false : _ref5$isLoading,
      onClose = _ref5.onClose,
      onSubmit = _ref5.onSubmit,
      validator = _ref5.validator;
    var _useTranslation5 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation5.t;
    var validate = function validate(values) {
      var errors = {};
      var error = (0, _isFunction["default"])(validator) && validator(values.email);
      if (error) errors = {
        email: error
      };
      return errors;
    };
    var Buttons = actionType === 'update' ? UpdateButtonGroup : AddButtonGroup;
    return /*#__PURE__*/_react["default"].createElement(FormContainer, {
      validate: validate,
      onSubmit: onSubmit,
      title: t("recoveryMethod.form.".concat(actionType, ".email.title")),
      subtitle: t("recoveryMethod.form.".concat(actionType, ".email.subtitle")),
      actions: function actions(_ref6) {
        var isValid = _ref6.isValid;
        return /*#__PURE__*/_react["default"].createElement(Buttons, {
          disabled: !isValid,
          isLoading: isLoading,
          onClose: onClose
        });
      }
    }, function (formikProps) {
      return /*#__PURE__*/_react["default"].createElement(EmailField, null);
    });
  };
};
var makePhoneNumberForm = function makePhoneNumberForm(actionType) {
  return function (_ref7) {
    var _ref7$isLoading = _ref7.isLoading,
      isLoading = _ref7$isLoading === void 0 ? false : _ref7$isLoading,
      enabledCountries = _ref7.enabledCountries,
      onClose = _ref7.onClose,
      onSubmit = _ref7.onSubmit,
      _ref7$initialValues = _ref7.initialValues,
      initialValues = _ref7$initialValues === void 0 ? {} : _ref7$initialValues;
    var ref = (0, _react.useRef)();
    var _useTranslation6 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation6.t;
    var validate = function validate(values) {
      var errors = {};
      if (values.phoneNumber.length === 0) {
        errors.phoneNumber = 'Required';
      } else if (values.phoneNumber === initialValues.phoneNumber) {
        // Validated phone number
      } else if (ref.current && !ref.current.isValidNumber()) {
        errors.phoneNumber = 'Invalid phone number';
      }
      return errors;
    };
    var Buttons = actionType === 'update' ? UpdateButtonGroup : AddButtonGroup;
    return /*#__PURE__*/_react["default"].createElement(FormContainer, {
      validate: validate,
      onSubmit: onSubmit,
      initialValues: initialValues,
      isInitialValid: !!initialValues.phoneNumber,
      title: t("recoveryMethod.form.".concat(actionType, ".phone.title")),
      subtitle: t("recoveryMethod.form.".concat(actionType, ".phone.subtitle")),
      actions: function actions(_ref8) {
        var isValid = _ref8.isValid;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
          className: "text-sm text-light mb-4 -mt-2"
        }, t('sms.consent')), /*#__PURE__*/_react["default"].createElement(Buttons, {
          disabled: !isValid,
          isLoading: isLoading,
          onClose: onClose
        }));
      }
    }, function (formikProps) {
      return /*#__PURE__*/_react["default"].createElement(PhoneNumberField, (0, _extends2["default"])({}, formikProps, {
        ref: ref,
        enabledCountries: enabledCountries
      }));
    });
  };
};
var UpdateEmailForm = exports.UpdateEmailForm = makeEmailForm('update');
var AddEmailForm = exports.AddEmailForm = makeEmailForm('add');
var UpdatePhoneNumberForm = exports.UpdatePhoneNumberForm = makePhoneNumberForm('update');
var AddPhoneNumberForm = exports.AddPhoneNumberForm = makePhoneNumberForm('add');
//# sourceMappingURL=Form.js.map